
export default {
  props: {
    imageURL: {
      type: String,
      required: true
    },
    direction: {
      type: String,
      required: false
    },
    overlay: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    imageClasses() {
      let classes
      if (this.overlay) classes = 'img-with-overlay'
      if (this.direction == 'left') {
        classes += ' direction-tl'
      } else if (this.direction == 'right') {
        classes += ' direction-tr'
      }
      return classes
    }
  }
}
